import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Mark comments read when the thread is mounted, not when its GET is prefetched.
    this.element.requestSubmit()
  }
}
